/**
 * Full-width tagline strip shown on every page directly under the header.
 * Uses the logo palette (blue, orange, purple) to draw attention with editorial typography.
 */
import { Link } from "react-router-dom";
import BrowseAllMenu from "@/components/BrowseAllMenu";

export const TaglineBanner = () => (
  <section
    data-testid="tagline-banner"
    aria-label="Social Pulse tagline"
    className="relative w-full overflow-hidden border-b"
    style={{ background: "var(--wofy-surface)", borderColor: "var(--wofy-border)" }}
  >
    {/* Soft coloured light-spots to keep the strip warm & vibrant without a heavy gradient */}
    <span aria-hidden className="pointer-events-none absolute -top-16 -left-10 w-72 h-72 rounded-full blur-3xl opacity-30" style={{ background: "var(--wofy-primary)" }} />
    <span aria-hidden className="pointer-events-none absolute -bottom-20 left-1/3 w-72 h-72 rounded-full blur-3xl opacity-25" style={{ background: "var(--wofy-accent)" }} />
    <span aria-hidden className="pointer-events-none absolute -top-16 -right-10 w-72 h-72 rounded-full blur-3xl opacity-30" style={{ background: "var(--wofy-secondary)" }} />

    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-8 md:py-12">
      <div className="flex flex-col gap-6">
        <div className="flex-1 min-w-0">
          <p
            data-testid="tagline-text"
            className="font-display leading-[1.15] tracking-tight text-xl sm:text-2xl md:text-[1.7rem] lg:text-3xl"
          >
            <span style={{ color: "var(--wofy-primary)" }}>Connecting People</span>
            <span style={{ color: "var(--wofy-text-soft)" }}>, </span>
            <span style={{ color: "var(--wofy-secondary)" }}>Preserving Memories</span>
            <span style={{ color: "var(--wofy-text-soft)" }}>, </span>
            <span style={{ color: "#B25D38" }}>Strengthening Families</span>
            <span style={{ color: "var(--wofy-text-soft)" }}>, </span>
            <span style={{ color: "var(--wofy-accent)" }}>Supporting Communities</span>
            <span style={{ color: "var(--wofy-text-soft)" }}>, </span>
            <span style={{ color: "#7C3AED" }}>Celebrating Lives</span>
            <span style={{ color: "var(--wofy-text-soft)" }}>, and </span>
            <span style={{ color: "#0E7C86" }}>Helping Businesses Thrive</span>
            <span style={{ color: "var(--wofy-text)" }}> is </span>
            <span
              className="font-display italic"
              style={{
                color: "var(--wofy-primary)", // fallback if gradient-clip unsupported
                background: "linear-gradient(90deg, var(--wofy-primary), #B25D38, var(--wofy-secondary), #7C3AED)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >Word of Joy!</span>
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <Link
              to="/donate"
              data-testid="tagline-donate-link"
              className="text-xs sm:text-sm italic underline underline-offset-4 hover:opacity-80"
              style={{ color: "var(--wofy-primary)" }}
            >
              Support Social Pulse Global Initiatives — Make a Donation
            </Link>
            <BrowseAllMenu />
            <Link
              to="/submit-cause"
              data-testid="tagline-submit-cause"
              className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-white hover:opacity-90 transition-opacity whitespace-nowrap"
              style={{ background: "var(--wofy-secondary)" }}
            >
              Submit a Cause / Plea (Request)
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
